import { MarketChainUid } from "@silo/types";
import { Array, Data, HashMap, pipe } from "effect";

/**
 * Mutable map that uses chain + market address as the key
 */
export class MarketChainMap<T> {
  private hashMap: HashMap.HashMap<MarketChainUid, T>;

  constructor() {
    this.hashMap = HashMap.empty();
  }

  public get(key: MarketChainUid) {
    const { chainKey, marketAddress } = key;

    return pipe(
      this.hashMap,
      HashMap.get(Data.struct({ chainKey, marketAddress }))
    );
  }

  public set(key: MarketChainUid, value: T) {
    const { chainKey, marketAddress } = key;

    const newHashMap = pipe(
      this.hashMap,
      HashMap.set(Data.struct({ chainKey, marketAddress }), value)
    );

    this.hashMap = newHashMap;
  }

  public size() {
    return HashMap.size(this.hashMap);
  }

  public entries() {
    return HashMap.entries(this.hashMap);
  }
}
